import { forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { Button, Dropdown, Form, Input, Modal, Select, Space, Spin, Typography } from 'antd';
import Table from '../../TableResizable';
import { Box, Grid } from '@mui/material';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import axios from 'axios';
import SweetAlert from 'sweetalert2';
//import { apiEndpoints } from '../../../config';
import { Crypter } from '../../../Functions/Security/Crypter';
import { SettingOutlined, CheckSquareOutlined, CloseSquareOutlined, SearchOutlined, DownloadOutlined, FileExcelOutlined, FilePdfOutlined, FileWordOutlined, FileTextOutlined, FileOutlined, ThunderboltOutlined, UploadOutlined, UndoOutlined } from '@ant-design/icons';
import { GlobalExportToCSV, GlobalExportToExcel, GlobalExportToJSON, GlobalExportToPDF, GlobalExportToWord } from '../../../utilitaires/globalFunction';
import InputForm from '../../InputT';
import SearchModal from '../../SearchModal';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import PCEMF from '../../../Models/PCEMF';
import Data from '../../../Data/Data.json';
import * as XLSX from 'xlsx';
import { exportPcemfConfig, getPcemfDefaults, importPcemfConfig, importPcemfConfigFromRows, pcemfConfigToRows, resetPcemfConfig } from './pcemfDefaults';

let searchCtegoCli: ParamsPicklist = { CodeAgence: 'TYPCLI', Table: 'LIB', Colonne1: 'CODLIB', Colonne2: 'LIBELL', Colagence: 'RUBRIQ', Choix: 22 };
let searchCtegoCpt: ParamsPicklist = { CodeAgence: 'CATEGOCPT', Table: 'LIB', Colonne1: 'CODLIB', Colonne2: 'LIBELL', Colagence: 'RUBRIQ', Choix: 22 };
let searchTypCPT: ParamsPicklist = { CodeAgence: 'TYPCPT', Table: 'LIB', Colonne1: 'CODLIB', Colonne2: 'LIBELL', Colagence: 'RUBRIQ', Choix: 22 };
let searchTypSens: ParamsPicklist = { CodeAgence: 'SENSEC', Table: 'LIB', Colonne1: 'CODLIB', Colonne2: 'LIBELL', Colagence: 'RUBRIQ', Choix: 22 };
let searchTypInt: ParamsPicklist = { CodeAgence: '', Table: 'COMMIS', Colonne1: 'CODCOM', Colonne2: 'LIBELL', Colagence: '101', Choix: 22 };

interface BatchItem {
  IDPLAN: string;
  LIBELL: string;
  TYPCPT: string;
  TYPCLI: string;
  categocpt: string;
  codprod: string;
  codage: string;
  sensSolde: string;
  NIVDEB: number;
  NIVCRE: number;
  DURVIE: number;
  SOLMIN: number;
  SOLMAX: number;
  TYPCPT2: string;
  CALINT: string;
  TXCRED: number;
  TXDEBI: number;
  TYPIN1: string;
  Niveau?: number;
}

const NUMBER_FIELDS = ['NIVDEB', 'NIVCRE', 'DURVIE', 'SOLMIN', 'SOLMAX', 'TXCRED', 'TXDEBI'];

const FIELD_OPTIONS = [
  { value: 'TYPCPT', label: 'Type compte' },
  { value: 'TYPCLI', label: 'Type client' },
  { value: 'categocpt', label: 'Catégorie compte' },
  { value: 'codprod', label: 'Code produit' },
  { value: 'codage', label: 'Code agence' },
  { value: 'sensSolde', label: 'Sens solde' },
  { value: 'TYPCPT2', label: 'Type compte 2' },
  { value: 'CALINT', label: 'Calcul intérêts' },
  { value: 'TYPIN1', label: 'Type intérêts 1' },
  { value: 'NIVDEB', label: 'Niveau débit' },
  { value: 'NIVCRE', label: 'Niveau crédit' },
  { value: 'DURVIE', label: 'Durée vie' },
  { value: 'SOLMIN', label: 'Solde minimum' },
  { value: 'SOLMAX', label: 'Solde maximum' },
  { value: 'TXCRED', label: 'Taux crédit' },
  { value: 'TXDEBI', label: 'Taux débit' },
];

const getDefaultConfig = (user: any): Partial<BatchItem> => ({});

// Les valeurs par défaut PCEMF (table de correspondance) ne sont plus appliquées
// automatiquement : elles s'appliquent uniquement via le bouton "Config. par défaut".
const buildBatchItem = (pcemf: PCEMF, user: any): BatchItem => ({
  ...getDefaultConfig(user),
  IDPLAN: pcemf.Code,
  LIBELL: pcemf.Libelle,
  Niveau: pcemf.Niveau,
} as BatchItem);

const formatNumberValues = (values: any): any => {
  const copy = { ...values };
  NUMBER_FIELDS.forEach(f => {
    if (copy[f] !== undefined) copy[f] = Number(copy[f]) || 0;
  });
  return copy;
};

const renderEditor = (field: string, formInstance: any) => {
  const defaultCode = formInstance ? formInstance.getFieldValue(field) : undefined;
  switch (field) {
    case 'TYPCPT':
      return (
        <SearchModal
          width={0}
          Titre=''
          label='Type compte'
          name='TYPCPT'
          Taille1='100%'
          Taille2='100%'
          Parametre={searchTypCPT}
          form={formInstance}
          notRequired
          defaultCode={defaultCode}
        />
      );
    case 'TYPCLI':
      return (
        <SearchModal
          width={0}
          Titre=''
          label='Type client'
          name='TYPCLI'
          Taille1='100%'
          Taille2='100%'
          Parametre={searchCtegoCli}
          form={formInstance}
          notRequired
          defaultCode={defaultCode}
        />
      );
    case 'categocpt':
      return (
        <SearchModal
          width={0}
          Titre=''
          label='Catégorie compte'
          name='categocpt'
          Taille1='100%'
          Taille2='100%'
          Parametre={searchCtegoCpt}
          form={formInstance}
          notRequired
          defaultCode={defaultCode}
        />
      );
    case 'sensSolde':
      return (
        <SearchModal
          width={0}
          Titre=''
          label='Sens solde'
          name='sensSolde'
          Taille1='100%'
          Taille2='100%'
          Parametre={searchTypSens}
          form={formInstance}
          notRequired
          defaultCode={defaultCode}
        />
      );
    case 'TYPIN1':
      return (
        <SearchModal
          width={0}
          Titre=''
          label='Type intérêts 1'
          name='TYPIN1'
          Taille1='100%'
          Taille2='100%'
          Parametre={searchTypInt}
          form={formInstance}
          notRequired
          defaultCode={defaultCode}
        />
      );
    case 'NIVDEB':
      return <InputForm width={12} label='Niveau débit' type='number' name='NIVDEB' notRequired />;
    case 'NIVCRE':
      return <InputForm width={12} label='Niveau crédit' type='number' name='NIVCRE' notRequired />;
    case 'DURVIE':
      return <InputForm width={12} label='Durée vie' type='number' name='DURVIE' notRequired />;
    case 'SOLMIN':
      return <InputForm width={12} label='Solde minimum' type='number' name='SOLMIN' notRequired />;
    case 'SOLMAX':
      return <InputForm width={12} label='Solde maximum' type='number' name='SOLMAX' notRequired />;
    case 'TXCRED':
      return <InputForm width={12} label='Taux crédit' type='number' name='TXCRED' notRequired />;
    case 'TXDEBI':
      return <InputForm width={12} label='Taux débit' type='number' name='TXDEBI' notRequired />;
    case 'IDPLAN':
      return <InputForm width={12} label='ID Plan' type='text' name='IDPLAN' disabled notRequired />;
    case 'LIBELL':
      return <InputForm width={12} label='Libellé' type='text' name='LIBELL' noupercase notRequired />;
    default:
      return <InputForm width={12} label={field} type='text' name={field} notRequired />;
  }
};

const TabBatchPCEMF = forwardRef((_, ref) => {
  const authHeader = useAuthHeader();
  const auth = useAuthUser();
  const user = auth() as any;
  const [loading, setLoading] = useState(false);
  const [batchItems, setBatchItems] = useState<BatchItem[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [groupField, setGroupField] = useState<string>('TYPCPT');
  const [searchTerm, setSearchTerm] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [modalItem, setModalItem] = useState<BatchItem | null>(null);
  const [form] = Form.useForm();
  const [groupForm] = Form.useForm();
  const importInputRef = useRef<HTMLInputElement>(null);

  useImperativeHandle(ref, () => ({
    saveBatch: async (action: 'ECRASER' | 'MANQUANTS' | 'FUSIONNER') => {
      if (batchItems.length === 0) {
        SweetAlert.fire({ title: 'Aucune donnée', text: 'Aucun PCEMF à enregistrer.', icon: 'warning' });
        return;
      }
      setLoading(true);
      try {
        const items = batchItems.map(({ Niveau, ...rest }) => rest);
        const payload = { Action: action, Utilisateur: user?.coduti ?? user?.NomUser ?? 'ADMIN', Items: items };
        const cypher = Crypter.encrypt(JSON.stringify(payload));
        const res = await axios.post(Data.ApiUrl.createBatchPlanCp, JSON.stringify(cypher), {
          headers: { Authorization: authHeader(), 'Content-Type': 'application/json' }
        });
        const raw = JSON.parse(Crypter.decrypt(res.data));
        const decrypted = raw.Value ?? raw;
        if (decrypted.StatutCode === 200) {
          SweetAlert.fire({ title: 'Succès', text: decrypted.Message, icon: 'success' });
        } else {
          SweetAlert.fire({ title: 'Erreur', text: decrypted.Message, icon: 'error' });
        }
      } catch (ex: any) {
        SweetAlert.fire({ title: 'Erreur', text: ex.message, icon: 'error' });
      }
      setLoading(false);
    }
  }));

  useEffect(() => {
    groupForm.resetFields();
  }, [groupForm, groupField]);

  const loadPCEMF = async () => {
    setLoading(true);
    try {
      const res = await axios.get(Data.ApiUrl.LirePCEMF, {
        headers: { Authorization: authHeader(), 'Content-Type': 'application/json' }
      });
      const raw = JSON.parse(Crypter.decrypt(res.data));
      const decrypted = raw.Value ?? raw;
      if (decrypted.StatutCode === 200) {
        const list: PCEMF[] = decrypted.Result?.Table || decrypted.Result || [];
        setBatchItems(list.map(p => buildBatchItem(p, user)));
      } else {
        SweetAlert.fire({ title: 'Erreur', text: decrypted.Message, icon: 'error' });
      }
    } catch (ex: any) {
      SweetAlert.fire({ title: 'Erreur', text: ex.message, icon: 'error' });
    }
    setLoading(false);
  };

  useEffect(() => {
    loadPCEMF();
  }, []);

  const filteredItems = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) return batchItems;
    return batchItems.filter(item =>
      Object.values(item).some(val => String(val ?? '').toLowerCase().includes(term))
    );
  }, [batchItems, searchTerm]);

  const selectAll = () => setSelectedRowKeys(filteredItems.map(i => i.IDPLAN));
  const deselectAll = () => setSelectedRowKeys([]);

  const buildExportData = () => filteredItems.map(item => ({
    'ID Plan': item.IDPLAN,
    'Libellé': item.LIBELL,
    'Niveau': item.Niveau ?? '',
    'Type compte': item.TYPCPT ?? '',
    'Type client': item.TYPCLI ?? '',
    'Catégorie compte': item.categocpt ?? '',
    'Sens solde': item.sensSolde ?? '',
    'Code produit': item.codprod ?? '',
    'Code agence': item.codage ?? '',
    'Niveau débit': item.NIVDEB ?? '',
    'Niveau crédit': item.NIVCRE ?? '',
    'Durée vie': item.DURVIE ?? '',
    'Solde min': item.SOLMIN ?? '',
    'Solde max': item.SOLMAX ?? '',
    'Type compte 2': item.TYPCPT2 ?? '',
    'Calcul intérêts': item.CALINT ?? '',
    'Taux crédit': item.TXCRED ?? '',
    'Taux débit': item.TXDEBI ?? '',
    'Type intérêts 1': item.TYPIN1 ?? '',
  }));

  const handleExport = (format: string) => {
    const data = buildExportData();
    const titre = 'Plan comptable PCEMF';
    const fileName = 'PlanComptablePCEMF';
    switch (format) {
      case 'excel': GlobalExportToExcel(data, titre, fileName); break;
      case 'pdf': GlobalExportToPDF(data, titre, fileName); break;
      case 'word': GlobalExportToWord(data, titre, fileName); break;
      case 'csv': GlobalExportToCSV(data, titre, fileName); break;
      case 'json': GlobalExportToJSON(data, titre, fileName); break;
      default: break;
    }
  };

  const exportMenuItems = [
    { key: 'excel', label: 'Excel (.xlsx)', icon: <FileExcelOutlined style={{ color: '#107C41' }} /> },
    { key: 'pdf', label: 'PDF (.pdf)', icon: <FilePdfOutlined style={{ color: '#d32f2f' }} /> },
    { key: 'word', label: 'Word (.docx)', icon: <FileWordOutlined style={{ color: '#2B579A' }} /> },
    { key: 'csv', label: 'CSV (.csv)', icon: <FileTextOutlined style={{ color: '#0288d1' }} /> },
    { key: 'json', label: 'JSON (.json)', icon: <FileOutlined style={{ color: '#7b1fa2' }} /> },
  ];

  // Applique la config par défaut (table de correspondance) aux lignes
  // sélectionnées, ou à toutes les lignes filtrées si aucune sélection.
  const applyDefaultConfig = async () => {
    const targetKeys = selectedRowKeys.length > 0 ? selectedRowKeys : filteredItems.map(i => i.IDPLAN);
    if (targetKeys.length === 0) {
      SweetAlert.fire({ title: 'Aucune donnée', text: 'Aucune ligne à configurer.', icon: 'warning' });
      return;
    }
    const scope = selectedRowKeys.length > 0
      ? `${targetKeys.length} ligne(s) sélectionnée(s)`
      : `toutes les lignes affichées (${targetKeys.length})`;
    const confirm = await SweetAlert.fire({
      title: 'Config. par défaut',
      text: `Appliquer la configuration par défaut (Type compte, Type client, Catégorie, Sens solde) sur ${scope} ?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Appliquer',
      cancelButtonText: 'Annuler',
    });
    if (!confirm.isConfirmed) return;
    setBatchItems(prev => prev.map(item =>
      targetKeys.includes(item.IDPLAN) ? { ...item, ...getPcemfDefaults(item.IDPLAN) } : item
    ));
    SweetAlert.fire({
      title: 'Appliqué',
      text: `Configuration par défaut appliquée sur ${targetKeys.length} ligne(s).`,
      icon: 'success',
      timer: 1800,
      showConfirmButton: false,
    });
  };

  // Télécharge un Blob via un lien temporaire (évite les dépendances bloquantes).
  const downloadBlob = (blob: Blob, filename: string) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };

  // Exporte la config par défaut active (JSON ou Excel).
  const handleExportConfig = (format: 'json' | 'excel') => {
    try {
      const rows = pcemfConfigToRows();
      console.log('[PCEMF] export config', format, rows.length, 'rows');
      const fileName = `ConfigDefautPCEMF_${new Date().toISOString().slice(0, 10)}`;
      if (format === 'excel') {
        const ws = XLSX.utils.json_to_sheet(rows);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Config');
        const buffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        downloadBlob(new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), `${fileName}.xlsx`);
        SweetAlert.fire({ title: 'Export Excel', text: `Fichier ${fileName}.xlsx généré.`, icon: 'success', timer: 1500, showConfirmButton: false });
        return;
      }
      downloadBlob(new Blob([exportPcemfConfig()], { type: 'application/json' }), `${fileName}.json`);
      SweetAlert.fire({ title: 'Export JSON', text: `Fichier ${fileName}.json généré.`, icon: 'success', timer: 1500, showConfirmButton: false });
    } catch (ex: any) {
      console.error('[PCEMF] export config error', ex);
      SweetAlert.fire({ title: 'Export impossible', text: ex.message, icon: 'error' });
    }
  };

  // Importe un fichier de config par défaut JSON ou Excel (remplace la config active).
  const handleImportConfig = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;
    const isExcel = /\.(xlsx|xls|csv)$/i.test(file.name);
    const reader = new FileReader();
    reader.onload = () => {
      try {
        if (isExcel) {
          const wb = XLSX.read(reader.result, { type: 'array' });
          const ws = wb.Sheets[wb.SheetNames[0]];
          importPcemfConfigFromRows(XLSX.utils.sheet_to_json(ws));
        } else {
          importPcemfConfig(String(reader.result));
        }
        SweetAlert.fire({
          title: 'Config importée',
          text: `"${file.name}" chargé. Cliquez sur "Config. par défaut" pour l'appliquer aux lignes.`,
          icon: 'success',
        });
      } catch (ex: any) {
        SweetAlert.fire({ title: 'Import impossible', text: ex.message, icon: 'error' });
      }
    };
    if (isExcel) reader.readAsArrayBuffer(file);
    else reader.readAsText(file);
  };

  const handleResetConfig = () => {
    resetPcemfConfig();
    SweetAlert.fire({
      title: 'Config réinitialisée',
      text: 'La configuration par défaut intégrée a été restaurée.',
      icon: 'success',
      timer: 1800,
      showConfirmButton: false,
    });
  };

  const applyGroup = () => {
    if (selectedRowKeys.length === 0) {
      SweetAlert.fire({ title: 'Aucune sélection', text: 'Veuillez sélectionner au moins une ligne.', icon: 'warning' });
      return;
    }
    const rawValue = groupForm.getFieldValue(groupField);
    const isNumber = NUMBER_FIELDS.includes(groupField);
    const value = isNumber ? (Number(rawValue) || 0) : rawValue;
    if (value === undefined || value === null || value === '') {
      SweetAlert.fire({ title: 'Valeur vide', text: 'Veuillez renseigner une valeur à appliquer.', icon: 'warning' });
      return;
    }
    const count = selectedRowKeys.length;
    setBatchItems(prev => prev.map(item => selectedRowKeys.includes(item.IDPLAN) ? { ...item, [groupField]: value } : item));
    setSelectedRowKeys([]);
    groupForm.resetFields();
    SweetAlert.fire({
      title: 'Appliqué',
      text: `Champ ${groupField} mis à jour pour ${count} ligne(s).`,
      icon: 'success',
      timer: 1500,
      showConfirmButton: false
    });
  };

  const openConfig = (item: BatchItem) => {
    setModalItem(item);
    form.setFieldsValue(item);
    setModalVisible(true);
  };

  const handleSaveModal = () => {
    form.validateFields().then(values => {
      const formatted = formatNumberValues(values);
      setBatchItems(prev => prev.map(item => item.IDPLAN === modalItem?.IDPLAN ? { ...item, ...formatted } : item));
      setModalVisible(false);
    });
  };

  const columns = [
    { title: 'ID Plan', dataIndex: 'IDPLAN', key: 'IDPLAN', width: 120 },
    { title: 'Libellé', dataIndex: 'LIBELL', key: 'LIBELL', width: 260, ellipsis: true },
    { title: 'Niv.', dataIndex: 'Niveau', key: 'Niveau', width: 60 },
    { title: 'Type', dataIndex: 'TYPCPT', key: 'TYPCPT', width: 70 },
    { title: 'Client', dataIndex: 'TYPCLI', key: 'TYPCLI', width: 70 },
    { title: 'Catégorie', dataIndex: 'categocpt', key: 'categocpt', width: 90 },
    { title: 'Sens', dataIndex: 'sensSolde', key: 'sensSolde', width: 70 },
    { title: 'Produit', dataIndex: 'codprod', key: 'codprod', width: 90 },
    { title: 'Agence', dataIndex: 'codage', key: 'codage', width: 80 },
    {
      title: 'Action',
      key: 'actions',
      fixed: 'right' as const,
      width: 110,
      render: (_: any, record: BatchItem) => (
        <Button size='small' icon={<SettingOutlined />} onClick={() => openConfig(record)}>
          Config.
        </Button>
      ),
    },
  ];

  return (
    <div className='tabItem' >
      <Spin spinning={loading} size='large' tip='Traitement en cours...'>
        <Box width={"87%"}>
          {/* <Typography.Title level={5} style={{ color: '#0a6a55', marginBottom: 12 }}>
          Création batch via PCEMF
        </Typography.Title> */}

          <Box className='bordure1' style={{ marginBottom: 16, padding: 12 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box style={{ padding: 10, backgroundColor: 'rgba(15,155,126,0.06)', borderRadius: 8 }}>
                  <Typography.Text strong style={{ color: '#0a6a55', display: 'block', marginBottom: 8 }}>
                    Configuration groupée
                  </Typography.Text>
                  <Space direction='vertical' size='small' style={{ width: '100%' }}>
                    <Space wrap style={{ width: '100%' }}>
                      <Button icon={<CheckSquareOutlined />} onClick={selectAll} size='small'>
                        Tout sélectionner
                      </Button>
                      <Button icon={<CloseSquareOutlined />} onClick={deselectAll} size='small'>
                        Tout désélectionner
                      </Button>
                      <Typography.Text type='secondary' style={{ marginLeft: 12 }}>
                        {selectedRowKeys.length} / {filteredItems.length} sélectionné(s)
                      </Typography.Text>
                    </Space>

                    <Space wrap style={{ width: '100%' }}>
                      <Button
                        type='primary'
                        icon={<ThunderboltOutlined />}
                        size='small'
                        onClick={applyDefaultConfig}
                        disabled={batchItems.length === 0}
                      >
                        Config. par défaut
                      </Button>
                      <Button icon={<UploadOutlined />} size='small' onClick={() => importInputRef.current?.click()}>
                        Importer config (JSON/Excel)
                      </Button>
                      <Button icon={<FileOutlined style={{ color: '#7b1fa2' }} />} size='small' onClick={() => handleExportConfig('json')}>
                        Exporter config JSON
                      </Button>
                      <Button icon={<FileExcelOutlined style={{ color: '#107C41' }} />} size='small' onClick={() => handleExportConfig('excel')}>
                        Exporter config Excel
                      </Button>
                      <Button icon={<UndoOutlined />} size='small' onClick={handleResetConfig}>
                        Réinitialiser config
                      </Button>
                      <input
                        ref={importInputRef}
                        type='file'
                        accept='.json,.xlsx,.xls,.csv,application/json,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        style={{ display: 'none' }}
                        onChange={handleImportConfig}
                      />
                      <Typography.Text type='secondary'>
                        S'applique aux lignes sélectionnées, ou à toutes si aucune sélection.
                      </Typography.Text>
                    </Space>

                    <Space wrap align='center' style={{ width: '100%' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                        <Typography.Text strong style={{ minWidth: 50 }}>Champ :</Typography.Text>
                        <Select
                          style={{ width: 170 }}
                          size='large'
                          value={groupField}
                          onChange={setGroupField}
                          options={FIELD_OPTIONS}
                        />
                        <Form form={groupForm} layout='inline' style={{ display: 'inline-flex', alignItems: 'center' }}>
                          <div style={{ minWidth: 200 }}>
                            {renderEditor(groupField, groupForm)}
                          </div>
                        </Form>
                        <Button type='primary' size='large' onClick={applyGroup} disabled={selectedRowKeys.length === 0} style={{ marginLeft: 16 }}>
                          Appliquer
                        </Button>
                      </div>
                    </Space>
                  </Space>
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box className='bordure1' style={{ padding: 12 }}>
            <Space style={{ width: '100%', justifyContent: 'space-between', marginBottom: 12 }} wrap>
              <Input
                allowClear
                prefix={<SearchOutlined style={{ color: '#0a6a55' }} />}
                placeholder='Recherche globale (ID, libellé, type, catégorie...)'
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                style={{ width: 340 }}
                size='large'
              />
              <Space>
                <Typography.Text type='secondary'>
                  {filteredItems.length} / {batchItems.length} ligne(s)
                </Typography.Text>
                <Dropdown
                  menu={{ items: exportMenuItems, onClick: ({ key }) => handleExport(key) }}
                  trigger={['click']}
                  placement='bottomRight'
                  getPopupContainer={(trigger) => trigger.parentElement ?? document.body}
                  disabled={filteredItems.length === 0}
                >
                  <Button type='primary' icon={<DownloadOutlined />} size='large'>
                    Exporter
                  </Button>
                </Dropdown>
              </Space>
            </Space>
            <Table
              rowSelection={{ selectedRowKeys, onChange: setSelectedRowKeys }}
              dataSource={filteredItems}
              columns={columns}
              rowKey='IDPLAN'
              size='small'
              tableLayout='fixed'
              scroll={{ x: 'max-content', y: 320 }}
            />
          </Box>

          <Modal
            title={`Configuration minimal - ${modalItem?.IDPLAN}`}
            open={modalVisible}
            onOk={handleSaveModal}
            onCancel={() => setModalVisible(false)}
            width={900}
            okText='Appliquer'
          >
            {modalItem && (
              <Form form={form} layout='vertical' initialValues={modalItem}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    {renderEditor('IDPLAN', form)}
                    {renderEditor('LIBELL', form)}
                    {renderEditor('TYPCPT', form)}
                    {renderEditor('TYPCLI', form)}
                    {renderEditor('categocpt', form)}
                    {renderEditor('codprod', form)}
                    {renderEditor('codage', form)}
                    {renderEditor('sensSolde', form)}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    {renderEditor('NIVDEB', form)}
                    {renderEditor('NIVCRE', form)}
                    {renderEditor('DURVIE', form)}
                    {renderEditor('SOLMIN', form)}
                    {renderEditor('SOLMAX', form)}
                    {renderEditor('TYPCPT2', form)}
                    {renderEditor('CALINT', form)}
                    {renderEditor('TXCRED', form)}
                    {renderEditor('TXDEBI', form)}
                    {renderEditor('TYPIN1', form)}
                  </Grid>
                </Grid>
              </Form>
            )}
          </Modal>
        </Box>
      </Spin>
    </div>
  );
});

export default TabBatchPCEMF;
